import { useCallback, useContext } from "react";
import { Select } from "@mantine/core";
import { EditableInfoRowContext } from "./EditableInfoRowContext";

interface InlineSelectProps {
  data: { value: string; label: string }[];
  defaultValue: string | null;
  placeholder?: string;
  searchable?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  onChange: (value: string | null, label?: string) => void;
}

export function InlineSelect({
  data,
  defaultValue,
  placeholder,
  searchable,
  disabled,
  style,
  onChange,
}: InlineSelectProps) {
  const setOverride = useContext(EditableInfoRowContext);
  const handleChange = useCallback(
    (value: string | null) => {
      if (!value) return;
      const selected = data.find((item) => item.value === value);
      if (selected && setOverride) setOverride(selected.label);
      onChange(value, selected?.label);
    },
    [data, onChange, setOverride]
  );

  return (
    <Select
      size="xs"
      data={data}
      defaultValue={defaultValue}
      placeholder={placeholder}
      searchable={searchable}
      disabled={disabled}
      style={style}
      onChange={handleChange}
    />
  );
}
